export class User {
    dbId = -1;
    loginId = "";
    userCd = -1;
    //   isTwoFactor = false;
    userKbn = -1;
    userType = -1;
    employeeNumber = "";
    employeeName = "";
    isMt = false;
    isTenent = false;
    isHeadquarters = false;
    departmentCode = -1;
    departmentName = "";
    isAgreeTermsOfUse = false;
    impersonationUser = null;
    isImpersonation = false;
    impersonationNyukyoNo = -1;
    isPasswordReset = false;
}
